module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./home-sidemenus.md");


//////////////////
// WEBPACK FOOTER
// ./src/components/routes/home-sidemenus.md
// module id = 345
// module chunks = 5 48